import { SelectInput } from '../baseInputs'

type GradeOption = {
  label: string
  value?: string
  response_code?: string
}

type Props = {
  grades?: GradeOption[]
  helper?: string
  optional?: boolean
}

const Grade = ({ grades, helper, optional }: Props) => {
  const name = 'grade'
  const label = 'Grade'

  if (!grades || grades.length === 0) {
    return null
  }

  const options = grades.map((grade) => ({
    label: grade.label,
    value: grade.value || grade.label,
  }))

  return (
    <SelectInput
      name={name}
      label={label}
      options={options}
      helper={helper}
      optional={optional}
    />
  )
}

export default Grade
